// Seleção de texto nas linhas/cards do board é sempre acidental — o gesto útil
// é clique (drawer/ficha) ou arraste pela alça. Chamado no mouseup do
// container: descarta qualquer seleção viva que o arrasto fora da alça criou.
export default function clearTextSelection() {
   const sel = window.getSelection?.();
   if (sel && !sel.isCollapsed) sel.removeAllRanges();
}
